/* unplugin-vue-components disabled */import script from "./editfield.vue?vue&type=script&setup=true&name=EditField&lang=js"
export * from "./editfield.vue?vue&type=script&setup=true&name=EditField&lang=js"

import "./editfield.vue?vue&type=style&index=0&id=ffda4710&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffda4710"]])

export default __exports__